export default {
  process: {
    step1: 'Shelf Setup',
    step2: 'Element Layout',
    step3: 'Gameplay Settings',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
  },
  step1: {
    setting1: {
      title: 'Shelf Rows and Columns',
      rowCol: 'Row-Col Count',
      row: 'Rows',
      col: 'Columns',
      reverse: '[Row-Col Count] Swap for landscape/portrait. ',
      reverseTip:
        'After selecting, the grid numbers in portrait and landscape modes are arranged as follows:<br/>In portrait mode, the grid numbers are:<br/>1 2<br/>3 4<br/>5 6<br/>In landscape mode, the grid numbers are:<br/>1 3 5<br/>2 4 6',
      layout: 'Arrangement',
      align: 'Alignment',
      colDisLocation: 'Column Misalignment',
      rowDisLocation: 'Row Misalignment',
    },
    setting2: {
      title: 'Shelf',
      gridSize: 'Grid',
      followGridImg: 'By Grid Image',
      wholeSize: 'Overall',
      gridImg: 'Grid Image',
      gridImgUpload: 'Please Upload Grid Image',
      shelvesImg: 'Shelf Image',
      shelvesImgUpload: 'Please Upload Shelf Image',
      shelvesPivot: 'Shelf Anchor Point',
      shelvesPivotDesc:
        'Green dot is the grid<br/>You can move the green dot to adjust the shelf position',
    },
  },
  step2: {
    setting1: {
      title: 'Single Grid Settings',
      goodsNum: 'Number of Elements in Each Grid',
      padding: 'Inner Padding',
      left: 'Left',
      right: 'Right',
      up: 'Top',
      down: 'Bottom',
    },
    setting2: {
      goods: 'Element',
      selectGoods: 'Please Select Element Image',
      error: 'The current quantity is not sufficient eliminate all.',
    },
    setting3: {
      title: 'Advanced Settings',
      weight: 'Arrange by weight',
      highlight: 'Element Outer Glow',
      blur: 'Blur',
      preview: 'Preview Style',
      closePreview: 'Close Preview',
      apply: 'Apply',
      weightErrorTip:
        'The sum of weights must be equal to 100%, please reconfigure',
    },
  },
  step3: {
    setting1: {
      title: 'Specific Gameplay Grid',
      addBtn: 'Add Specific Gameplay Grid',
      grid: 'Grid',
    },
    setting2: {
      title: 'Grid State After Elimination',
      reserve: 'Retain Grid',
      reserveEff: 'Retain Effect',
      close: 'Close',
      noClose: "Don't Close",
      closeImage: 'Close Image',
      uploadCloseImage: 'Please Upload Close Image',
      closeImageTip:
        'After selecting an image, you can choose the default closed grids on the canvas. These grids will appear in a closed state at the beginning of the game.',
      remove: 'Grid Elimination',
      removeEff: 'Drop Gameplay',
      fall: 'Drop',
      noFall: "Don't Drop",
    },
    setting3: {
      title: 'Frontend Default Value',
      remove: 'Eliminate',
      noRemove: "Don't Eliminate",
      closeOrNot: 'Is it closed?',
      fallTitle: 'Will the upper grid drop?',
      fall: 'Drop',
      noFall: "Don't Drop",
    },
  },
}
